import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel, Container } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

import ShopCard from '../shop-card';
import LearnCard from '../learn-card';
import QuizCard from '../quiz-card';

const ShopLearnPanel = ({ data, className, ...other }) => {
	const [activePanel, setActivePanel] = useState(1);

	const onToggleClick = (index) => {
		setActivePanel(index);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'shopLearnToggle',
			value: data.toggle[index].heading,
		});
	};

	return (
		<div
			className={`togglePanels bg-gray-5 py-6 md:py-10 ${className || ''}`}
			{...other}
		>
			<Container>
				<div className='togglePanels-intro relative'>
					{data.heading && <h2 dangerouslySetInnerHTML={{ __html: data.heading }} />}

					{data.subheading && (
						<div
							className='togglePanels-subheading text-subtitle mt-5 xl:mt-2 xl:max-w-prose'
							dangerouslySetInnerHTML={{ __html: data.subheading }}
						/>
					)}

					{isValidArray(data.toggle) && (
						<div className='togglePanels-toggle my-6 flex w-full border border-gray-40 bg-white p-1 sm:w-80 xl:absolute xl:right-0 xl:top-1/2 xl:my-0 xl:-translate-y-1/2'>
							{data.toggle.map((toggle, index) => (
								<button
									className={`togglePanels-toggleBtn flex-1 ${activePanel === index ? 'bg-black text-white' : 'text-gray-60'} py-1.5 text-center text-base font-semibold`}
									onClick={() => onToggleClick(index)}
									key={index}
								>
									{toggle.heading}
								</button>
							))}
						</div>
					)}
				</div>

				{isValidArray(data.toggle) &&
					data.toggle.map((group, parentIndex) => {
						if (parentIndex !== activePanel) return null;

						return (
							<div
								key={parentIndex}
								className='shopLearn-group mt-5 md:mt-6'
							>
								{group.group?.[0] && (
									<Carousel
										key={activePanel}
										className='xl:grid xl:grid-cols-2 xl:grid-rows-2 xl:!gap-4 xl:overflow-hidden [&>li]:!w-auto'
										wrapperClassName='max-md:[&>p]:mt-6 [&>p]:!mb-0'
										arrowsClassName='md:max-xl:[&_button]:-mt-10'
										slidePadding={16}
										center={false}
										showArrows
										showSlideCount
									>
										{parentIndex === 0 &&
											group.group.map((item, index) => (
												<ShopCard
													data={item}
													key={index}
												/>
											))}
										{parentIndex > 0 &&
											group.group.slice(0, 3).map((item, index) => (
												<LearnCard
													data={item}
													key={index}
												/>
											))}
										{parentIndex > 0 && group.group?.[3] && <QuizCard data={group.group[3]} />}
									</Carousel>
								)}
							</div>
						);
					})}
			</Container>
		</div>
	);
};

ShopLearnPanel.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default ShopLearnPanel;
